import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("canvas", {
    ref: "canvas",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.draw && $options.draw(...args)),
    width: "140",
    height: "40",
    style: {
      "cursor": "pointer"
    }
  }, null, 512);
}